var $6vrdg$eventtargetshim = require("event-target-shim");
var $6vrdg$koajax = require("koajax");
var $6vrdg$tarofetchpolyfill = require("taro-fetch-polyfill");
var $6vrdg$webstreamspolyfill = require("web-streams-polyfill");
var $6vrdg$webutility = require("web-utility");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "request", function () { return $28f4352c648c0ad8$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "parseResponse", function () { return $28f4352c648c0ad8$export$ba14d9a5a581e827; });
$parcel$export(module.exports, "parseFetchBody", function () { return $28f4352c648c0ad8$export$b7b86d31099674dc; });





class $f9e9db99a57b3121$export$863d066dc35784fb extends (0, $6vrdg$eventtargetshim.Event) {
    constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
        super(type, meta);
        this.lengthComputable = lengthComputable;
        this.total = total;
        this.loaded = loaded;
    }
}
async function $f9e9db99a57b3121$export$ad2db95f22033cc(iterableOrArrayLike) {
    if (typeof iterableOrArrayLike[Symbol.asyncIterator] !== 'function') iterableOrArrayLike = Array.from(iterableOrArrayLike);
    const result = [];
    for await (const item of iterableOrArrayLike)result.push(item);
    return result;
}


var $0823386a0949b924$exports = {};

$parcel$export($0823386a0949b924$exports, "streamFromProgress", function () { return $0823386a0949b924$export$f8162fcba31fa547; });
$parcel$export($0823386a0949b924$exports, "emitStreamProgress", function () { return $0823386a0949b924$export$cebfdbc318a33abe; });


const $0823386a0949b924$export$f8162fcba31fa547 = (target)=>(0, $6vrdg$webutility.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            next({
                loaded: loaded,
                total: total
            });
            if (loaded >= total) complete();
        };
        target.addEventListener('progress', handleProgress);
        target.addEventListener('error', error);
        return ()=>{
            target.removeEventListener('progress', handleProgress);
            target.removeEventListener('error', error);
        };
    });
async function* $0823386a0949b924$export$cebfdbc318a33abe(stream, total, eventTarget) {
    var loaded = 0;
    for await (const chunk of stream){
        yield chunk;
        loaded += chunk.byteLength;
        const event = new (0, $f9e9db99a57b3121$export$863d066dc35784fb)('progress', {
            lengthComputable: isNaN(total),
            loaded: loaded,
            total: total
        });
        eventTarget.dispatchEvent(event);
    }
}


function $28f4352c648c0ad8$export$b5fe3f66a567bec0({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof (0, $6vrdg$tarofetchpolyfill.Headers) ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === 'text' ? {
        ...headers,
        Accept: 'text/plain'
    } : responseType === 'json' ? {
        ...headers,
        Accept: 'application/json'
    } : responseType === 'document' ? {
        ...headers,
        Accept: 'text/html, application/xhtml+xml, application/xml'
    } : responseType === 'arraybuffer' || responseType === 'blob' ? {
        ...headers,
        Accept: 'application/octet-stream'
    } : headers;
    const isStream = body instanceof (0, $6vrdg$webstreamspolyfill.ReadableStream);
    var upload;
    if (isStream) {
        const uploadProgress = new (0, $6vrdg$eventtargetshim.EventTarget)();
        body = (0, $6vrdg$webstreamspolyfill.ReadableStream).from((0, $0823386a0949b924$export$cebfdbc318a33abe)(body, +headers['Content-Length'], uploadProgress));
        upload = (0, $0823386a0949b924$export$f8162fcba31fa547)(uploadProgress);
    }
    const downloadProgress = new (0, $6vrdg$eventtargetshim.EventTarget)();
    const response = (0, $6vrdg$tarofetchpolyfill.fetch)(path + '', {
        method: method,
        headers: headers,
        credentials: withCredentials ? 'include' : 'omit',
        body: body,
        signal: signals[0] && AbortSignal.any(signals),
        // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
        duplex: isStream ? 'half' : undefined
    }).then((response)=>$28f4352c648c0ad8$export$ba14d9a5a581e827(response, responseType, downloadProgress));
    return {
        response: response,
        upload: upload,
        download: (0, $0823386a0949b924$export$f8162fcba31fa547)(downloadProgress)
    };
}
async function $28f4352c648c0ad8$export$ba14d9a5a581e827({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress) {
    const stream = (0, $6vrdg$webstreamspolyfill.ReadableStream).from((0, $0823386a0949b924$export$cebfdbc318a33abe)(body, +headers.get('Content-Length'), downloadProgress));
    const contentType = headers.get('Content-Type') || '';
    const header = (0, $6vrdg$koajax.parseHeaders)([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join('\n'));
    const rBody = status === 204 ? undefined : await $28f4352c648c0ad8$export$b7b86d31099674dc(stream, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $28f4352c648c0ad8$export$b7b86d31099674dc(stream, contentType, responseType) {
    const blob = new (0, $6vrdg$tarofetchpolyfill.Blob)(await (0, $f9e9db99a57b3121$export$ad2db95f22033cc)(stream), {
        type: contentType
    });
    if (responseType === 'blob') return blob;
    if (responseType === 'arraybuffer') return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === 'text') return text;
    return (0, $6vrdg$koajax.parseBody)(text, contentType);
}
$parcel$exportWildcard(module.exports, $0823386a0949b924$exports);


//# sourceMappingURL=index.js.map
